import { useFlag } from '@/services/featureFlags/FeatureFlags';
import styled from '@emotion/styled';
import { GeneralContainer, RootContainer, SubTitle, Title, TitleContainer } from '../common';
import { CreativityLevel } from './CreativityLevel';
import { GroundingSelection } from './GroundingSelection/GroundingSelection';
import { KnowledgeSourceSelection } from './KnowledgeSourceSelection';
import { LLMSelect } from './LLMSelect';
import theme from '@/theme';

const StyledRootContainer = styled(RootContainer)`
    gap: 24px;
`;

const StyledTitle = styled(Title)`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
`;

const SourceSelectionContainer = styled(GeneralContainer)`
    gap: 16px;
`;

const ConversationModeContainer = styled(GeneralContainer)`
    gap: 16px;
`;

export const AgentKnowledgeBase = () => {
    const agentLLMSelect = useFlag('agent_llm_select', false);

    return (
        <StyledRootContainer>
            <ConversationModeContainer>
                <TitleContainer>
                    <Title>Conversation mode</Title>
                    <SubTitle>Choose whether the agent sticks to provided info or includes broader insights</SubTitle>
                </TitleContainer>
                <GroundingSelection />
            </ConversationModeContainer>
            <SourceSelectionContainer>
                <TitleContainer>
                    <Title>Knowledge base</Title>
                    <SubTitle>
                        Use knowledge snippets to add quick context for your avatar, or upload files to provide a broader knowledge base for
                        its responses.
                    </SubTitle>
                </TitleContainer>
                <GeneralContainer>
                    <KnowledgeSourceSelection />
                </GeneralContainer>
            </SourceSelectionContainer>
            <GeneralContainer>
                <CreativityLevel />
            </GeneralContainer>
            {agentLLMSelect && (
                <GeneralContainer>
                    <StyledTitle>LLM</StyledTitle>
                    <LLMSelect />
                </GeneralContainer>
            )}
        </StyledRootContainer>
    );
};
